import { useState } from "react";
import { Modal } from "react-bootstrap";
import { createType } from "../../api/internetpackage";

export default function ModalCreateType({ show, onClose, onSuccess }) {
  let [form, setForm] = useState({name: '', description: ''});
  let [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({show: false, message: '', type: ''});
  
  const handleClose = () => {
    setForm({name: '', description: ''});
    setAlert({show: false, message: '', type: ''})
    onClose(false);
  }

  const submitData = (event) => {
    event.preventDefault();
    createInternetPackage(form)
  }

  const createInternetPackage = async (form) => {
    setLoading(true);
    try {
      let response = await createType({ ...form });
      onSuccess(true, response.data.message, response.data.data);
      handleClose();
    } catch (error) {
      let message = ""
      if (error.response) {
        let { data } =  error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({show: true, message, type: 'danger'})
    }

    setLoading(false);
  }

  return (
    <Modal show={show} onHide={() => handleClose()}>
      <form onSubmit={event => submitData(event)}>
        <Modal.Header closeButton>
          <Modal.Title>Buat Tipe Paket Baru</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {alert.show &&
            <div className={`alert alert-${alert.type} alert-dismissible fade show`} role="alert">
              {alert.message}
              <button type="button" className="close"  onClick={() => setAlert({show: false, message: '', type: ''})} aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          }

          <div className="form-group">
            <label htmlFor="">Nama Tipe Paket <span className="text-danger">*</span></label>
            <input type="text" className="form-control" required value={form.name} onChange={event => setForm({ ...form, name: event.target.value})} />
          </div>
          <div className="form-group">
            <label htmlFor="">Deskripsi <span className="text-danger">*</span></label>
            <textarea type="text" className="form-control" required value={form.description} onChange={event => setForm({ ...form, description: event.target.value})} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type="button" className="btn btn-secondary" onClick={() => handleClose()}>Close</button>
          <button type="submit" className="btn btn-primary" disabled={loading}><i className="fas fa-plus"></i> Buat Tipe Paket Baru</button>
        </Modal.Footer>
      </form>
    </Modal>
  )
}